export const blockIconsToggleStarOutline = (
	<span className='material-symbols-outlined'>star_outline</span>
);
